import {
  createIcons,
  Activity,
  AtSign,
  AudioLines,
  Brain,
  ReceiptText,
  Layers,
  Gauge,
  FolderKanban,
  Box,
  Camera,
  ChevronRight,
  CircleCheck,
  Columns2,
  Clapperboard,
  CopyPlus,
  Download,
  FileText,
  GitBranch,
  History,
  Image,
  LayoutDashboard,
  LayoutGrid,
  ListChecks,
  MapPin,
  MessagesSquare,
  Mic,
  Monitor,
  MonitorPlay,
  NotebookPen,
  Palette,
  Pause,
  PenLine,
  PenTool,
  Play,
  Radio,
  Recycle,
  Ruler,
  Save,
  ScanText,
  Scissors,
  SlidersHorizontal,
  Smartphone,
  Sparkles,
  Sun,
  Users,
  UsersRound,
  WandSparkles,
  Workflow,
} from "lucide";

const landingIcons = {
  Activity,
  AtSign,
  AudioLines,
  Box,
  Brain,
  Camera,
  CircleCheck,
  Columns2,
  FolderKanban,
  Gauge,
  Layers,
  ReceiptText,
  ChevronRight,
  Clapperboard,
  CopyPlus,
  Download,
  FileText,
  GitBranch,
  History,
  Image,
  LayoutDashboard,
  LayoutGrid,
  ListChecks,
  MapPin,
  MessagesSquare,
  Mic,
  Monitor,
  MonitorPlay,
  NotebookPen,
  Palette,
  Pause,
  PenLine,
  PenTool,
  Play,
  Radio,
  Recycle,
  Ruler,
  Save,
  ScanText,
  Scissors,
  SlidersHorizontal,
  Smartphone,
  Sparkles,
  Sun,
  Users,
  UsersRound,
  WandSparkles,
  Workflow,
};

export function drawLandingIcons() {
  createIcons({ icons: landingIcons, attrs: { "stroke-width": 1.75 } });
}
